import React, { useCallback } from 'react';

const UseFocusTrap = (
  containerRef: React.RefObject<HTMLElement>,
  focusSelectors: string[] = [
    'button:not([disabled])',
    '[tabindex]:not([tabindex="-1"])',
    '[role="button"]:not([aria-hidden="true"])',
  ]
) => {
  return useCallback(
    (e: React.KeyboardEvent<HTMLElement>) => {
      if (e.key !== 'Tab' || !containerRef.current) return;

      const selector = focusSelectors.join(', ');
      const focusableElements = Array.from(
        containerRef.current.querySelectorAll<HTMLElement>(selector)
      ).filter(el => el.offsetParent !== null);
      console.log(
        'Focusable elements:',
        focusableElements.map(el => el.textContent)
      );

      if (focusableElements.length === 0) return;

      const activeElement = document.activeElement as HTMLElement;
      const currentIndex = focusableElements.indexOf(activeElement);

      if (e.shiftKey) {
        if (currentIndex <= 0) {
          e.preventDefault();
          focusableElements[focusableElements.length - 1].focus();
        }
      } else {
        if (currentIndex === -1 || currentIndex === focusableElements.length - 1) {
          e.preventDefault();
          focusableElements[0].focus();
        }
      }
    },
    [containerRef, focusSelectors]
  );
};
export default UseFocusTrap;
